import detail from './detail';

class TemplatePublic {
    name = 'templatePublic';
    constructor() {
        this.detail = detail;
    }
}
export default new TemplatePublic();
